import type { DeviceKind } from '@shared/protocol';
import { keys, storage } from './storage';

const TV = /smart-?tv|tizen|web0s|webos|netcast|playstation|xbox|bravia|hbbtv|googletv|android tv|aft[a-z]|crkey|roku|viera|appletv/i;
const MOBILE = /mobi|android|iphone|ipod/i;

/** Detects the device class. `?device=tv` in the URL forces (and remembers) a mode — handy for testing on a laptop. */
export function detectDevice(): DeviceKind {
  const forced = new URLSearchParams(location.search).get('device');
  if (forced === 'tv' || forced === 'mobile' || forced === 'desktop') {
    storage.set(keys.device, forced);
    return forced;
  }
  const saved = storage.get(keys.device);
  if (saved === 'tv' || saved === 'mobile' || saved === 'desktop') return saved;
  const ua = navigator.userAgent;
  if (TV.test(ua)) return 'tv';
  if (MOBILE.test(ua) || (navigator.maxTouchPoints > 1 && Math.min(screen.width, screen.height) < 600)) return 'mobile';
  return 'desktop';
}

export function vibrate(pattern: number | number[]): void {
  try {
    // Before the first tap the browser blocks vibration and logs an error for every call.
    if ((navigator as Navigator & { userActivation?: { hasBeenActive: boolean } }).userActivation?.hasBeenActive === false) return;
    navigator.vibrate?.(pattern);
  } catch {
    /* unsupported */
  }
}
